import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withTranslation } from 'react-i18next'
import MobileWrapper from '../../components/MobileWrapper'
import MobileHeader from '../../components/MobileHeader'
import MobileContent from '../../components/MobileContent'
import DividedWhiteBox from '../../components/DividedWhiteBox'
import WhiteBox from '../../components/WhiteBox'
import DropDownSelect from '../../components/DropDownSelect'
import { getUser, getCreditCards } from '../../reducers/user'
import StyleButton from '../../components/StyleButton'
import {
  ADD_WALLET_VALUE,
  FETCH_CREDIT_CARD,
  fetchCreditCards,
  addWalletValue,
} from '../../actions/user'
import { moneyFormatter } from '../../utils/formatter'
import balanceIcon from '../../assets/images/payment/balance.png'
import tickIcon from '../../assets/images/common/tick.png'
import TextInput from '../../components/TextInput'
import { createLoadingSelector, createSuccessSelector } from '../../reducers/selector'
import { reset } from '../../actions/selector'
import PopupModal from '../../components/PopupModal'
import { FETCH_PAYMENT_SERVICE_CHARGES, fetchPaymentServiceCharges } from '../../actions/school'
import { getPaymentServiceCharges } from '../../reducers/school'

const styles = () => {
  return {
    paymentButtonContainer: {
      position: 'relative',
      height: '36px',
      margin: '10px',
    },
    paymentButton: {
      position: 'absolute',
      left: '25%',
      right: '25%',
      borderRadius: '50px',
      width: '50%',
      height: '36px',
      fontSize: '14px',
      color: 'white',
      border: 0,
      outline: 0,
    },
    totalContainer: {
      marginTop: '14px',
      fontWeight: 600,
      display: 'flex',
      justifyContent: 'space-between',
    },
    totalLabel: {
      float: 'left',
      textAlign: 'left',
    },
    totalAmount: {
      float: 'right',
      textAlign: 'right',
    },
    amountContainer: {
      backgroundColor: 'white',
      borderRadius: '50px',
      height: '40px',
      boxShadow: '0 3px 3px #D2D2D2',
      border: 0,
      outline: 0,
      width: '100%',
      paddingTop: '10px',
      paddingLeft: '20px',
      paddingBottom: '10px',
      textAlign: 'left',
      cursor: 'pointer',
      fontSize: '14px',
    },
    popupModalButtonContainer: {
      paddingTop: '5px',
      paddingBottom: '5px',
    },
    popupModalButton: {
      marginBottom: '5px',
    },
  }
}

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    creditCards: getCreditCards(state),
    isFetchCreditCardSuccess: createSuccessSelector([FETCH_CREDIT_CARD])(state),
    isFetchPaymentServiceChargesSuccess: createSuccessSelector([FETCH_PAYMENT_SERVICE_CHARGES])(
      state,
    ),
    paymentServiceCharges: getPaymentServiceCharges(state),
    isSubmitting: createLoadingSelector([ADD_WALLET_VALUE])(state),
    isSuccess: createSuccessSelector([ADD_WALLET_VALUE])(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCreditCards() {
      return dispatch(fetchCreditCards())
    },
    addWalletValue(cardId, value) {
      return dispatch(addWalletValue(cardId, value))
    },
    fetchPaymentServiceCharges() {
      return dispatch(fetchPaymentServiceCharges())
    },
    reset(type) {
      return dispatch(reset(type))
    },
  }
}

@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@withTranslation()
@injectSheet(styles)
class AddValuePage extends Component {
  state = {
    defaultPrecision: 2,
    selectedCreditCardId: null,
    amount: 0,
    isOpen: null,
    displayAddValueSuccessPopup: false,
    paymentMethod: 'alipay_hk',
  }

  get creditCards() {
    const { creditCards, t } = this.props
    return [
      ...creditCards.map((creditCard) => {
        return {
          name: `${creditCard.brand} - xxxx-xxxx-xxxx-${creditCard.card_last4}`,
          value: creditCard.id,
        }
      }),
      {
        name: t('new_credit_card'),
        value: 'NEW_CREDIT_CARD',
      },
    ]
  }

  get paymentMethods() {
    const { t } = this.props
    return [
      {
        type: 'paymentMethod',
        value: 'alipay',
        name: `${t('alipay')}`,
      },
    ]
  }

  handlePaymentMethodChange = (value) => {
    this.setState({
      paymentMethod: value,
      selectedCreditCardId: null,
    })
  }

  get amount() {
    const { user, location, t } = this.props
    const amountChoices = [
      { name: `${t('hkd')}$${moneyFormatter(20)}`, value: 20 },
      { name: `${t('hkd')}$${moneyFormatter(50)}`, value: 50 },
      { name: `${t('hkd')}$${moneyFormatter(100)}`, value: 100 },
      { name: `${t('hkd')}$${moneyFormatter(200)}`, value: 200 },
      { name: `${t('hkd')}$${moneyFormatter(500)}`, value: 500 },
      { name: `${t('hkd')}$${moneyFormatter(1000)}`, value: 1000 },
      { name: t('custom'), value: 'custom' },
    ]
    if (location.data && location.data.amount) {
      const amountNeeded = location.data.amount - parseFloat(user.wallet_balance)
      const newAmount = {
        name: `${t('hkd')}$${moneyFormatter(amountNeeded)}`,
        value: amountNeeded,
      }
      return [newAmount, ...amountChoices]
    }
    return amountChoices
  }

  handleAmountChoicesChange = (value) => {
    this.setState({
      amount: value,
    })
    if (value === 'custom') {
      this.setState({ isOpen: true })
    } else {
      this.setState({ isOpen: false })
    }
  }

  handleAmountChange = (amount) => {
    let { defaultPrecision } = this.state
    defaultPrecision = Number(defaultPrecision)

    if (/^0*$/.test(amount)) {
      this.setState({
        amount: parseFloat('0'),
      })
    } else {
      let updatedAmount = amount.replace(/^0+/, '')
      if (updatedAmount[0] === '.') {
        updatedAmount = `0${updatedAmount}`
      }

      if (updatedAmount.indexOf('.') > -1) {
        const separatedAmount = updatedAmount.split('.')
        const precision = separatedAmount[1].length

        if (precision < defaultPrecision) {
          this.setState({
            amount: parseFloat(updatedAmount),
          })
        } else {
          this.setState({
            amount: parseFloat(
              `${separatedAmount[0]}.${separatedAmount[1].slice(0, defaultPrecision)}`,
            ),
          })
        }
      } else {
        this.setState({
          amount: parseFloat(updatedAmount),
        })
      }
    }
  }

  handleCreditCardChange = (value) => {
    this.setState({ selectedCreditCardId: value })
    const { history, match } = this.props
    if (value === 'new') {
      history.push(`/school/${match.params.schoolCode}/user/wallet/credit_cards/add`)
    }
  }

  handleSubmitButtonClick = () => {
    const { selectedCreditCardId, amount } = this.state
    this.props.addWalletValue(selectedCreditCardId, amount)
  }

  handleDisplaySuccessPopupDismiss = () => {
    this.setState({
      displayAddValueSuccessPopup: false,
    })
  }

  handlePopupButtonClick = () => {
    const { history } = this.props
    this.setState({
      displayAddValueSuccessPopup: false,
    })
    history.goBack()
  }

  static getDerivedStateFromProps(props, state) {
    if (state.displayAddValueSuccessPopup !== props.isSuccess) {
      return {
        displayAddValueSuccessPopup: props.isSuccess,
      }
    }
    return null
  }

  get serviceChargeAmount() {
    const { paymentMethod, amount } = this.state
    const { paymentServiceCharges } = this.props
    if (Object.prototype.hasOwnProperty.call(paymentServiceCharges, paymentMethod)) {
      return amount * paymentServiceCharges[paymentMethod]
    }
    return 0
  }

  get totalAmount() {
    const { amount } = this.state
    return amount + this.serviceChargeAmount
  }

  componentDidMount() {
    this.props.reset(FETCH_CREDIT_CARD)
    this.props.reset(ADD_WALLET_VALUE)
    this.props.fetchCreditCards()
    this.props.fetchPaymentServiceCharges()
  }

  render() {
    const {
      location,
      classes,
      user,
      isFetchCreditCardSuccess,
      isSubmitting,
      isSuccess,
      isFetchPaymentServiceChargesSuccess,
      t,
    } = this.props
    const {
      amount, isOpen, paymentMethod, displayAddValueSuccessPopup,
    } = this.state
    return (
      <MobileWrapper overlay={true}>
        <MobileHeader title={t('online_add_value')} adjust={true} />
        {displayAddValueSuccessPopup && (
          <PopupModal
            title={t('success')}
            icon={tickIcon}
            onDismiss={this.handleDisplaySuccessPopupDismiss}
          >
            <p>{`${t('add_value')} ${t('success')}`}</p>
            <p>{`${t('my_balance')}: ${user.wallet_balance}`}</p>
            <div className={classes.popupModalButtonContainer}>
              <div className={classes.popupModalButton}>
                <StyleButton
                  name={t('ok')}
                  styleType={'secondary'}
                  onClick={this.handlePopupButtonClick}
                />
              </div>
            </div>
          </PopupModal>
        )}
        <MobileContent adjust={true}>
          <div>
            {location.data && (
              <DividedWhiteBox
                balance={`${t('hkd')}$${moneyFormatter(user.wallet_balance)}`}
                total={`${t('hkd')}$${moneyFormatter(location.data.amount)}`}
              />
            )}
            {!location.data && (
              <WhiteBox
                title={`${t('spc_wallet')}$${moneyFormatter(user.wallet_balance)}`}
                description={t('my_balance')}
                image={balanceIcon}
              />
            )}
            <div>
              <p>{t('which_payment_method_msg')}</p>
              <DropDownSelect
                items={this.paymentMethods}
                onItemChange={this.handlePaymentMethodChange}
              />
            </div>
            {paymentMethod === 'credit_card' && isFetchCreditCardSuccess && (
              <div>
                <p>{t('which_credit_card_msg')}</p>
                <DropDownSelect
                  items={this.creditCards}
                  onItemChange={this.handleCreditCardChange}
                />
              </div>
            )}
            <div>
              <p>{t('amount')}</p>
              <DropDownSelect items={this.amount} onItemChange={this.handleAmountChoicesChange} />
            </div>
            {isOpen && (
              <TextInput
                placeholder={t('amount')}
                type={'number'}
                onChange={this.handleAmountChange}
                value={amount}
              />
            )}
            <div className={classes.totalContainer}>
              <div className={classes.totalLabel}>{t('add_value_amount')}</div>
              <div className={classes.totalAmount}>{`${t('hkd')}$${moneyFormatter(amount)}`}</div>
            </div>
            <div className={classes.totalContainer}>
              <div className={classes.totalLabel}>{t('service_charge')}</div>
              <div className={classes.totalAmount}>
                {isFetchPaymentServiceChargesSuccess
                  && `${t('hkd')}$${moneyFormatter(this.serviceChargeAmount)}`}
              </div>
            </div>
            <div className={classes.totalContainer}>
              <div className={classes.totalLabel}>{t('total')}</div>
              <div className={classes.totalAmount}>
                {isFetchPaymentServiceChargesSuccess
                  && `${t('hkd')}$${moneyFormatter(this.totalAmount)}`}
              </div>
            </div>
            <div className={classes.paymentButtonContainer}>
              <div className={classes.paymentButton}>
                <StyleButton
                  name={t('confirm')}
                  styleType={'secondary'}
                  onClick={this.handleSubmitButtonClick}
                  disabled={!isFetchCreditCardSuccess || isSubmitting || isSuccess}
                />
              </div>
            </div>
          </div>
        </MobileContent>
      </MobileWrapper>
    )
  }
}

AddValuePage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
  }),
  classes: PropTypes.object,
  user: PropTypes.object,
  creditCards: PropTypes.array,
  paymentServiceCharges: PropTypes.object,
  isFetchCreditCardSuccess: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isSuccess: PropTypes.bool,
  location: PropTypes.shape({
    data: PropTypes.shape({
      amount: PropTypes.number,
    }),
  }),
  amount: PropTypes.string,
  fetchCreditCards: PropTypes.func,
  addWalletValue: PropTypes.func,
  isFetchPaymentServiceChargesSuccess: PropTypes.bool,
  fetchPaymentServiceCharges: PropTypes.func,
  reset: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  t: PropTypes.func,
}

export default AddValuePage
